import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { IconButton, Grid, Paper, Typography } from '@material-ui/core';
/*import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';*/
import { TypePersonData, BudgetYears, } from '../SlipData/components';

import { ReportList } from './components';
import mockData from './data';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: theme.spacing(1),
    overflowX: 'hidden'
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  button: {
    marginBottom: theme.spacing(1),
    textAlign: 'left'
  },
  paper: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    minHeight: '80px'
  }, heading: {
    fontSize: theme.typography.pxToRem(15),
  },
}));

const ReportData = () => {
  const classes = useStyles();
  const [typePersons, setTypePersons] = useState([]); // return value from child
  const [budgetYears, setBudgetYears] = useState(''); // return value from child 
  const [profile] = useState(JSON.parse(localStorage.getItem('profile')));

  const getTypePersonValue = TypePersonValue => {
    const result1 = Object.values(TypePersonValue);
    setTypePersons(result1);
  }

  const getBudgetYearValue = BudgetyearsValue => {
    setBudgetYears(BudgetyearsValue);
  }

  const [Reports] = useState(mockData);

  return (
    <div className={classes.root}>

      <div className={classes.content}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <Paper className={classes.paper}>
              <BudgetYears getBudgetYearValue={getBudgetYearValue} />
            </Paper>
          </Grid>
          <Grid item xs>
            <Paper className={classes.paper}>
              <TypePersonData financeuser={profile} getTypePersonValue={getTypePersonValue} />
            </Paper>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
        >
          {Reports.map(report => (
            <Grid
              item
              key={report.id}
              lg={4}
              md={6}
              xs={12}
            >
              <ReportList  typePersons={typePersons} budgetYears={budgetYears} report={report} />
            </Grid>
          ))}
        </Grid>
      </div>
      {/*<div className={classes.pagination}>
        <Typography variant="caption">1-6 of 20</Typography>
        <IconButton>
          <ChevronLeftIcon />
        </IconButton>
        <IconButton>
          <ChevronRightIcon />
        </IconButton>
          </div>*/}
    </div>
  );
};

export default ReportData;
